<template>
  <section
    class="alert-component mode-stacked emphasis-high"
    :class="{ [`type-${this.type}`]: true }"
    role="alert"
  >
    <span v-if="$slots.header">
      <div class="alert-header-component">
        <h2><slot name="header"></slot></h2>
      </div>
    </span>

    <span class="alert-content-container">
      <span v-if="$slots.content">
        <div
          class="alert-content-component"
          :class="{
            ['has-header']: !!$slots.header,
            ['has-actions']: !!$slots.actions,
          }"
        >
          <p>
            <slot name="content"></slot>
          </p>
        </div>
      </span>
      <span v-if="$slots.actions">
        <div class="alert-actions-component">
          <span>
            <slot name="actions"></slot>
          </span>
        </div>
      </span>
    </span>
  </section>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../legacy/scss/lib';

.alert-component {
  // TODO custom and not ported from researcher
  p,
  button {
    font-size: 14px;
  }

  // TODO custom and not ported from researcher
  button {
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    border-radius: 8px;
    padding: 8px 12px;
    white-space: nowrap;
  }

  // TODO custom and not ported from researcher
  margin-bottom: 16px;

  // &.mode-stacked .alert-content-container
  &.mode-stacked {
    @include flex-stack($gap: 0);
  }

  // TODO custom and not ported from researcher
  .alert-content-container {
    @include flex-stack($gap: 0);
  }

  // TODO custom and not ported from researcher
  @include media-md-up() {
    .alert-content-container {
      @include flex-between($flex-wrap: nowrap, $gap: 0);
    }
  }

  &:not(.mode-stacked) {
    @include media-md-up() {
      @include flex-between($flex-wrap: wrap, $gap: 0 8px);
    }

    @include media-xl-up() {
      @include flex-between($flex-wrap: nowrap, $gap: 0 8px);
    }
  }

  border-radius: $border-radius;

  // Add enough padding to reach spacing required
  // to align text and actions when stacked and
  // action is being hovered
  padding: 4px;

  // Remove transclude containers that are empty to
  // avoid an empty element effecting layout
  span:empty {
    display: none;
  }

  // Generate alert type combinations using the
  // status-palette with hover and focus states
  @each $key, $value in $status-palettes {
    &.type-#{$key} {
      background-color: status-palette($key, 'light');
      border: 1px solid status-palette($key, 'main');
      color: status-palette($key, 'dark');

      // TODO move a few of the styles into the child components
      @include apply-to-headings() {
        color: status-palette($key, 'dark');
      }

      a,
      button {
        color: status-palette($key, 'dark');
      }

      // TODO revisit with button mixin when available
      a.btn:hover,
      a.btn:focus,
      button.btn:hover,
      button.btn:focus {
        background-color: rgba(status-palette($key, 'main'), 0.25);
      }

      a:not(.btn) {
        text-decoration: underline;

        &:hover,
        &:focus {
          text-decoration: none;
        }
      }

      button:disabled {
        color: rgba(0, 0, 0, 0.38);

        &:hover,
        &:focus {
          background: transparent;
          color: rgba(0, 0, 0, 0.38);
        }
      }

      // TODO custom and not ported from researcher, and
      // can be removed as the button mixin is applied
      .btn-outlined {
        border-color: status-palette($key, 'dark');
      }
    }
  }

  .alert-content-component {
    @include flex-stack($gap: 8px);
    // Enforce a max-width to prevent the alert from taking up
    // too much horizontal space regardless of parent mode
    max-width: 600px;

    // Use content to pad outwards the required amount
    // that matches similar padding on actions button
    // and anchor elements
    margin: 12px 8px 12px 12px;

    // Strict control of spacing between content
    // elements for consistency between alerts
    & > * {
      margin: 0;
      padding: 0;
    }
  }

  .alert-actions-component {
    @include flex-base($flex-wrap: nowrap, $gap: 4px 8px);

    // TODO custom and not ported from researcher
    padding: 8px;
  }
}

.alert-header-component {
  // Enforce heading specific size, but allows for
  // the use of any heading level to meet hierarchy
  @include apply-to-headings() {
    @include typography-level('headline-6');

    margin: 0;
    padding: 0;
  }

  // Enforce a max-width to prevent the alert from taking up
  // too much horizontal space regardless of parent mode
  max-width: 600px;

  // Use content to pad outwards the required amount
  // that matches similar padding on actions button and
  // anchor elements with the exception of the bottom
  // margin which is controlled by the AlertContentComponent
  margin: 12px 8px 0 12px;

  // Strict control of spacing between content
  // elements for consistency between alerts
  & > * {
    margin: 0;
    padding: 0;
  }
}
</style>
